import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.1013 3.85H17.4322V2H15.4333V3.85H8.54715V2H6.54826V3.85H4.87918C3.83976 3.85 2.99023 4.72 2.99023 5.8V20.05C2.99023 21.12 3.83976 22 4.87918 22H19.1013C20.1407 22 20.9902 21.13 20.9902 20.05V5.8C20.9902 4.73 20.1407 3.85 19.1013 3.85ZM18.9913 20H4.99912V10.55H19.0013V20H18.9913ZM18.9913 8.55H4.99912V5.84H19.0013V8.55H18.9913ZM15.993 15.98H13.9941V13.99H15.993V15.98Z" fill={ fill || 'currentColor' }/>
    </svg>

);
